<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Processo Judicial"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import ProcessosJudiciaisServicos from './ProcessosJudiciaisServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        processo: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Processo Judicial do Contrato',
                html: `Confirma a exclusão do Processo Judicial de Número <b>${this.processo.codigo}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let processoDto = {
                contratoId: this.contrato.idContrato,
                idProcessoJudicialContrato: this.processo.idProcessoJudicialContrato
            }
            ProcessosJudiciaisServicos.excluir(processoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterProcessosAtualizados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
